
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie'
Vue.use(VueI18n);
// 获取当前浏览器默认语言 
let defaut_lang = navigator.language || navigator.browserLanguage;


if (defaut_lang) {
    if ( defaut_lang.toLowerCase().indexOf("zh") > -1) {
        defaut_lang = 'zh'
    } else {
        defaut_lang = 'en'
    }
}


const supportLang = {
            zh: '简体中文',
            en: 'English'
        },
supports = Object.keys(supportLang);

// 如果localstorage里存在lang 取lang 否则取浏览器默认
var lang = (Cookies.get('language') || '').toLowerCase() || (defaut_lang || '') || 'zh';
function checkValid(lang) {
    return lang && supports.indexOf(lang) > -1
}

if (!checkValid(lang)) {
   // 存
   Cookies.set('language',lang)
}

const LANG_MESSAGES = {
    'zh': require('./zh.json'),
    'en': require('./en.json')
}
const i18n = new VueI18n({
    locale: lang,
    messages: LANG_MESSAGES
  })

export const  updateLocal = lang => {
    i18n.locale = lang;
}
updateLocal(lang);
export default i18n




// WEBPACK FOOTER //
// ./src/lang/index.js